<button (click)="onClick(-1)" [disabled]="pageIndex === 0" class="icon icon-menu icon-arrow-previous"></button>

<div class="text">
    <span class="current">{{ pageIndex + 1 }}</span> / {{ totalPages }}
</div>

<button (click)="onClick(1)" [disabled]="pageIndex === totalPages - 1" class="icon icon-menu icon-arrow-next"></button>
